import {Storm} from "./Storm";
import {MI} from "../init.js";
import {copyArray, getRandomBoolean, getRandomInt, shuffleArray} from "../../framework/src/helpers";

/**
 * @constructor
 * @extends {Storm}
 * @param {MadnesGroup} group
 * @returns {StormSearch}
 */
export function StormSearch(group) {
    Storm.call(this, group);
}

StormSearch.prototype = Object.create(Storm.prototype);
StormSearch.prototype.constructor = StormSearch;

/**
 * @param {number} reelId
 * @returns {number}
 */
StormSearch.prototype._getReelPosX = function(reelId) {

    var x = 0;

    if(reelId === 1) {
        x = getRandomInt(340, 440);
    } else if(reelId === 2) {
        x = getRandomInt(580, 680);
    } else {
        x = getRandomInt(820, 920);
    }

    return x;

};

StormSearch.prototype.create = function(reelId) {

    var a = shuffleArray(copyArray(Storm.flashNumbers));

    for(var i = 0; i < 3; i++) {
        this._flashes[i] = MI.addImg(this._getReelPosX(reelId), 0, "storm_0" + a[i]);
        this._flashes[i].setAnchor(0.5, 0).setVisible(false).setAlpha(0);
        this._group.add(this._flashes[i]);

        if(getRandomBoolean()) {
            this._flashes[i].setScale(-1, 1);
        }
    }

};

StormSearch.prototype.run = function() {
    var _self = this;
    this._isRunning = true;

    for(var i = 0; i < this._flashes.length; i++) {
        (function(i) {

            var timer = MI.createTimer().add(function() {

                var flashAnim = _self._playFlashAnim(_self._flashes[i]).then(function() {
                    _self._flashes[i].destroy();
                    delete _self._flashes[i];
                });

                _self._flashesPromises.push(flashAnim);

            }, i * 600);

            _self._flashesTimers.push(timer);

        }(i));
    }
};